import { useSelector } from 'react-redux';
import { selectBuilderId } from '../../selectors/builder';
import { useBuilderToBanksMap } from './hooks/useBuilderToBanksMap';
import { AccreditationBanks } from '../../components/AccreditationBanks';
import * as React from 'react';

export const AccreditationBanksContainer = () => {
  const buildersToBanksMap = useBuilderToBanksMap();
  const id = useSelector(selectBuilderId);

  const banks = buildersToBanksMap[id];

  if (!banks?.length) {
    return null;
  }

  return <AccreditationBanks banks={banks} />;
};
